import LocalizedStrings from "react-localization";

export const viewMappingDetailsMetadataStrings = new LocalizedStrings({
  en: {
    date: "Date",
    id: "ID",
    sponsoredType: "Sponsored Type",
    advertiserName: "Advertiser Name",
    advertiserPaid: "Advertiser Paid",
    link: "Site Link",
    title: "Title",
  },
  fr: {
    date: "Date",
    id: "ID",
    sponsoredType: "Sponsored Type",
    advertiserName: "Advertiser Name",
    advertiserPaid: "Advertiser Paid",
    link: "Site Link",
    title: "Title",
  },
});
